import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthenticateMagicLink } from '@hooks/auth/useMagicLink';
import {
  getMagicLinkAuthErrorKey,
  getSafeAuthRedirect,
  type MagicLinkAuthErrorKey,
} from './verify-helpers';

const VerifyMagicLink: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const { mutate: authenticateMagicLink } = useAuthenticateMagicLink();
  const [errorKey, setErrorKey] = useState<MagicLinkAuthErrorKey | null>(
    token ? null : getMagicLinkAuthErrorKey(),
  );

  useEffect(() => {
    if (!token) {
      return;
    }

    authenticateMagicLink(token, {
      onSuccess: (res) => navigate(getSafeAuthRedirect(res.redirect_url), { replace: true }),
      onError: (authError) => setErrorKey(getMagicLinkAuthErrorKey(authError)),
    });
  }, [token, navigate, authenticateMagicLink]);

  return (
    <div className="flex justify-center items-center min-h-screen bg-white px-4 sm:px-8">
      <div className="w-full max-w-[420px] text-center">
        {errorKey ? (
          <>
            <h1 className="text-[20px] font-bold text-[#111827] mb-2">{t(errorKey)}</h1>
            <p className="text-[14px] text-[#6B7280] mb-6">{t('auth.verify.requestNew')}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="w-full py-3 rounded text-[14px] font-medium bg-[#2563EB] text-white hover:opacity-90 transition-opacity"
            >
              {t('auth.verify.backToSignIn')}
            </button>
          </>
        ) : (
          <>
            <div className="w-10 h-10 mx-auto mb-4 border-4 border-[#E5E7EB] border-t-[#2563EB] rounded-full animate-spin" />
            <p className="text-[14px] text-[#6B7280]">{t('auth.verify.signingIn')}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyMagicLink;
